export const Workshops = {

    // Job Readiness
    "job-readiness": {
        name: "Job Readiness",
        refName: "job-readiness",
        about: `Getting a job is one of the most crucial junctures of one's life, marking the transformation from being a student to being professional. This workshop helps you in learning the industry trends from senior professionals from various top firms around the globe and get a clear picture along with some mock interviews.`,
        fee: `Registration Fee - RS.350`,
        dateTime: [
            "Date - 27/03/2021",
            "Time - 10 am to 4 pm"
        ],

        speakers: [
            {
                name: "Palanidaran Chidambaram",
                href:"https://www.linkedin.com/mwlite/in/palanidaranchidambaram",
                profession: "Director, Appstore and Cross-Screen Tech",
                img:"Palanidaran.jpeg",
                company:"Amazon India"
            },
            {
                name: "Akshay Ramesh",
                href:"https://www.linkedin.com/in/akshay-ramesh-309ab040/",
                profession: "Lead BI Developer",
                img:"Akshay.jpg",
                company:"Visual BI Solutions"
            },
            {
                name: "Nivetha Govindan",
                href:"https://www.linkedin.com/in/nivetha-govindan-8a44a1137",
                profession: "Associate Developer",
                img:"Nivetha.jpeg",
                company:"Sap Labs India"
            },
            {
                href:"https://www.linkedin.com/mwlite/in/rangarajan-sridhar-6a3429192",
                name: "Rangarajan Sridhar",
                profession: "Tech Program App Dev 1",
                img:"Rangarajan.jpeg",
                company:"Citicorp Services India Pvt Ltd"
            },
            
        ], 
        // sponsor: "",
        contact: [
            {
                name: "Shakthi prarthana V",
                mobile: "8778594649"
            },
            {
                name: "Aarti V",
                mobile: "7824888744"
            }
        ],

        agenda: {
            number: 2,
            sessionDetails: [
                {
                    title: "Session 1",
                    description: [
                        "A session on the changing trends in the IT industry over the years and a discussion on what is needed for today’s trends",
                        "A session on the technical interviews and tips to crack them",
                        "A discussion on the expectations to be fulfilled by interviewees in the managerial and HR rounds",
                    ]
                },
                {
                    title: "Session 2",
                    description: [
                        "Hands on session for resume building",
                        "Mock interviews"
                    ]
                },
            ]
        },
        prerequisite: [
            "Participants must have their updated resumes with them while attending the session",
            "Participants must ensure that they have microsoft account"
        ],
        registration: true,
        purpose: "PLACEMENTS"
    },

    // Entrepreneurship
    "entrepreneurship": {
        name: "Entrepreneurship",
        refName: "entrepreneurship",

        about: `Have you ever dreamt of building your own business?
                Entrepreneurship is the key to unlock your future. 
                Brush up the knowledge required to embark on an 
                entrepreneurial journey with this workshop. 
                Also learn how to build effective relationships and other tactics to 
                launch your own business. Awaken the Entrepreneur in you and make your ideas 
                come alive.`,
        fee: `Registration Fee - RS.350`,
        dateTime: [
            "Date : 26/03/2021",
            "Time : 10 am to 4 pm"
        ],
         speakers: [
            {
                 name:"Hariharan Ganesan",
                href:"https://www.linkedin.com/in/4hari/",
                profession: "Head of Digital & Engineering Capability",
                img:"Hariharan.jpg",
                company:"Rolls-Royce India Pvt. Ltd."
                
            },
            
           {
            name:"Santhosh Muruganantham",
           href:"https://www.linkedin.com/in/santhoshmuruganantham/",
           profession: "Co Founder & Managing Director",
           img:"santhosh.jpg",
           company:"kolapasi"
           
       },
         
        ], 
        contact: [
            {
                name: "Keerthana S",
                mobile: "9962007286"
            },
            {
                name: "Raghavaraju Kavya Sree",
                mobile: "6302101554"
            }
        ],

        // sponsor: "",

        /* agenda: {
            number: 2,
            sessionDetails: [
                {
                    title: "Session 1",
                    description: [
                        "A session on the changing trends in the IT industry over the years and a discussion on what is needed for today’s trends",
                        "A session on the technical interviews and tips to crack them",
                        "A discussion on the expectations to be fulfilled by interviewees in the managerial and HR rounds",
                    ]
                },
                {
                    title: "Session 2",
                    description: [
                        "Hands on session for resume building",
                        "Mock interviews"
                    ]
                },
            ]
        }, */
        prerequisite: [
            "Participants must ensure that they have laptop with good internet connectivity for their convenience",
            "Participants must ensure that they have microsoft account"   
        ],
        registration: true,
        purpose: "ENTREPRENEURSHIP"
    },

    // Cloud Computing
    "cloud-computing": {
        name: "Cloud Computing",
        refName: "cloud-computing",
        about: `Unlock the future of data storage and computing power through our cloud computing workshop. You will learn how to apply concepts with cloud services and work with relevant tools and platforms like AWS, Azure, Google Cloud and DevOps from experts at Walmart.`,
        fee: `Registration Fee - RS.350`,
        dateTime: [
            "Date - 27/03/2021",
            "Time - 10 am to 4 pm"
        ],
         speakers: [
            {
                name:"Thiyagarajan Balasubramanian",
                href:" https://www.linkedin.com/in/thiyagab/",
                profession: "Senior Manager",
                img:"Thiyagarajan Balasubramanian.jpeg",
                company:"Walmart Global Tech India" 
            },
            /*{
                name: "Paargav",
                profession: "xyz"
            },
            {
                name: "Paargav",
                profession: "xyz"
            },
            {
                name: "Paargav",
                profession: "xyz"
            }*/
        ], 
        contact: [
            {
                name: "Varshini E",
                mobile: "9962768298"
            },
            {
                name: "Ishaque S",
                mobile: "7010456755"
            }
        ],

        // sponsor: "",

        /* agenda: {
            number: 2,
            sessionDetails: [
                {
                    title: "Session 1",
                    description: [
                        "A session on the changing trends in the IT industry over the years and a discussion on what is needed for today’s trends",
                        "A session on the technical interviews and tips to crack them",
                        "A discussion on the expectations to be fulfilled by interviewees in the managerial and HR rounds",
                    ]
                },
                {
                    title: "Session 2",
                    description: [
                        "Hands on session for resume building",
                        "Mock interviews"
                    ]
                },
            ]
        }, */
        prerequisite: [
            "Participants must ensure that they have laptop with good internet connectivity for their convenience",
            "Participants must ensure that they have microsoft account"   
        ],
        registration: true,
        purpose: "CLOUD"
    },
}